import axios from 'axios';

export default {
    namespaced: true,
    state: {
        invoices: null,
        loadingInvoices: false,
        chargeDetail: null,
        transactionDetail: null,
        loadingChargeDetail: false,
        loadingTransactionDetail: false
    },
    mutations: {
        resetInvoices(state) {
            state.invoices = null;
        },
        loadInvoices(state) {
            state.loadingInvoices = true;
        },
        updateInvoices(state, data) {
            state.invoices = data;
            state.loadingInvoices = false;
        },
        resetChargeDetail(state) {
            state.chargeDetail = null;
        },
        loadChargeDetail(state) {
            state.loadingChargeDetail = true;
        },
        updateChargeDetail(state, data) {
            state.chargeDetail = data;
            state.loadingChargeDetail = false;
        },
        resetTransactionDetail(state) {
            state.transactionDetail = null;
        },
        loadTransactionDetail(state) {
            state.loadingTransactionDetail = true;
        },
        updateTransactionDetail(state, data) {
            state.transactionDetail = data;
            state.loadingTransactionDetail = false;
        }
    },
    actions: {
        getInvoices({ commit }) {
            commit('resetInvoices');
            commit('loadInvoices');
            axios
                .get('/invoices')
                .then(result => {
                    commit('updateInvoices', result.data.data);
                })
                .catch(console.error);
        },
        getInvoiceDetail({ commit }, id) {
            commit('resetChargeDetail');
            commit('loadChargeDetail');
            commit('resetTransactionDetail');
            commit('loadTransactionDetail');
            axios
                .get('/invoice/' + id)
                .then(result => {
                    commit('updateChargeDetail', result.data.data.chargeDetail);
                    commit(
                        'updateTransactionDetail',
                        result.data.data.transactionDetail
                    );
                })
                .catch(console.error);
        }
    }
};
